@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.popover-title {
  margin: 0;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  background-color: @product-page--inventory-popover--background-color;
  border-bottom: 1px solid @product-page--inventory-popover--border-color;
  border-radius: 5px 5px 0 0;
}

.popover-body {
  padding: 9px 14px;
  display: flex;
}

.popover-buttons {
  display: flex;
  justify-content: space-between;
  padding: 0 10px 10px;
}

.adjust-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: @product-page--inventory-popover-icon--text-color;

  .icon {
    width: 12px;
    height: 12px;
    fill: @product-page--inventory-popover-icon--fill-color;
  }

  &:hover {
    color: @product-page--inventory-popover-icon--hover--text-color;

    .icon {
      fill: @product-page--inventory-popover-icon--hover--fill-color;
    }
  }

  &:focus {
    color: @product-page--inventory-popover-icon--focus--text-color;

    .icon {
      fill: @product-page--inventory-popover-icon--focus--fill-color;
    }
  }
}
